<template>
    <div>
        <p></p>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
var json = 
{
  "data": {
    "getCargo": {
      "id": 1,
      "menuscargo": [
        {
          "idmenu": 48,
          "idcargo": 1,
          "visualizar": true,
          "value": 31,
          "menu": {
            "nombre": "Cargos",
            "value": null
          },
          "submenus": [
            {
              "nombre": "Ver cargos",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 1
            },
            {
              "nombre": "Listar cargos",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 2
            },
            {
              "nombre": "Agregar cargos",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 4
            },
            {
              "nombre": "Modificar cargos",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 8
            },
            {
              "nombre": "Eliminar cargos",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 16
            },
            {
              "nombre": "Listar menus",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 32
            },
            {
              "nombre": "Listar menu",
              "padre": {
                "nombre": "Cargos"
              },
              "value": 64
            }
          ]
        },
        {
          "idmenu": 78,
          "idcargo": 1,
          "visualizar": true,
          "value": 11,
          "menu": {
            "nombre": "Sedes",
            "value": null
          },
          "submenus": [
            {
              "nombre": "Listar sedes",
              "padre": {
                "nombre": "Sedes"
              },
              "value": 1
            },
            {
              "nombre": "Ver sedes",
              "padre": {
                "nombre": "Sedes"
              },
              "value": 2
            },
            {
              "nombre": "Agregar sedes",
              "padre": {
                "nombre": "Sedes"
              },
              "value": 4
            },
            {
              "nombre": "Modificar sedes",
              "padre": {
                "nombre": "Sedes"
              },
              "value": 8
            },
            {
              "nombre": "Eliminar sedes",
              "padre": {
                "nombre": "Sedes"
              },
              "value": 16
            },
            {
              "nombre": "Listar sedes por estado",
              "padre": {
                "nombre": "Sedes"
              },
              "value": 32
            }
          ]
        }
      ]
    }
  }
}


export default {
    props:{ model:Object,multiple:{type:Boolean,required:false,default:false} },
    data(){
        return{
            datos: [],
            modelo: {
                idprofesion: null,
            }
        }
    },
    watch:{
        'modelo.idprofesion': function(){this.model.idprofesion=this.modelo.idprofesion; }
    },
    methods:{
        async getDatos() {
            var vue = this;
            var sql = gql`query{getProfesiones{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                vue.datos = data.data.getProfesiones;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getProfesiones' ) )
            })
        },
        parseDatos(){
            var vue = this;
            json.data.getCargo.menuscargo.forEach(function(e){
                var bin = (e.value).toString(2).split('').reverse();
                var exp = 0;
                //window.console.log( "PARSE DATOS",e.value,bin )
                bin.forEach( function(i){
                    if( i == "1" ){
                        var valor = Math.pow(2,exp);
                        var sub = e.submenus.find( x => x.value == valor )
                        vue.$store.state.submenus.push( {id:sub.id,nombre:sub.nombre} );
                        //window.console.log( "BASE DOS",2,exp,valor,sub.nombre )
                    }
                    exp++;
                })
            });

            // window.console.log( "AMENUS.vue>>> SUBMENUS",JSON.stringify(this.$store.state.submenus) )
        },
    },
    mounted(){
        this.parseDatos();
    }
}
</script>